import React, { ReactNode } from 'react';
import { Routes, Route } from 'react-router-dom';
import { Layout } from 'antd';

import Home from './components/pages/Home';
import { SpeciesObservations, SpeciesPredictions } from './components/pages/Species';
import { SpeciesBirdIdentification } from './components/pages/SpeciesBirdIdentification';
import { SpeciesBirdGreekSpatialAnalysis } from './components/pages/SpeciesBirdGreekSpatialAnalysis';
import { SpeciesBirdGreekTemporalAnalysis } from './components/pages/SpeciesBirdGreekTemporalAnalysis';
import Habitat from './components/pages/Habitat';
import { LandUseLandCover, NdviIndicator } from './components/pages/Landscape';
import IndicatorsConservation from './components/pages/Indicators';
import Sidebar from './components/shared/Sidebar';
import AppHeader from './components/shared/Header';
import AppContent from './components/shared/Content';
import ProtectedRoute from './components/auth/ProtectedRoute';

import './css/Routes.css';
import EcosystemServices from './components/pages/Ecosystem';
import { useKeycloak } from '@react-keycloak/web';
import backgroundImage from './assets/images/test.jpg';

interface MainLayoutProps {
  children: ReactNode;
  menu: string;
}

const MainLayout: React.FC<MainLayoutProps> = (props) => {
  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Sidebar menu={props.menu} />
      <Layout className='site-layout' style={{ overflowY: 'auto' }}>
        <AppHeader />
        <AppContent>{props.children}</AppContent>
      </Layout>
    </Layout>
  );
};

const AppRoutes: React.FC = () => {
  const { initialized } = useKeycloak();
  if (!initialized) {
    return (
      <div
        style={{
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          height: '100vh',
          width: '100vw',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            padding: '2rem 3rem',
            borderRadius: '12px',
            fontSize: '1.5rem',
            fontWeight: 'bold',
            color: '#333',
          }}
        >
          Loading application authentication...
        </div>
      </div>
    );
  }

  const routes = [
    { path: '/', element: <Home />, menu: '1' },
    {
      path: '/species/observations',
      element: <SpeciesObservations />,
      menu: '3',
    },
    {
      path: '/species/predictions',
      element: <SpeciesPredictions />,
      menu: '4',
    },
    {
      path: '/species/acoustic',
      element: <SpeciesBirdIdentification />,
      menu: '11',
    },
    {
      path: '/greekCaseStudy/spatialAnalysis',
      element: <SpeciesBirdGreekSpatialAnalysis />,
      menu: '12',
    },
    {
      path: '/greekCaseStudy/temporalAnalysis',
      element: <SpeciesBirdGreekTemporalAnalysis />,
      menu: '13',
    },
    {
      path: '/indicators/conservation',
      element: <IndicatorsConservation />,
      menu: '5',
    },
    { path: '/habitat', element: <Habitat />, menu: '6' },
    { path: '/landscape', element: <LandUseLandCover />, menu: '7' },
    {
      path: '/landscape/land-use_land-cover',
      element: <LandUseLandCover />,
      menu: '8',
    },
    {
      path: '/landscape/ndvi_indicator',
      element: <NdviIndicator />,
      menu: '9',
    },
    {
      path: '/ecosystem',
      element: <EcosystemServices />,
      menu: '10',
    },
  ];
  return (
    <Routes>
      {/* Protected Routes */}
      {routes.map(({ path, element, menu }) => (
        <Route
          key={path}
          path={path}
          element={
            <ProtectedRoute>
              <MainLayout menu={menu}>{element}</MainLayout>
            </ProtectedRoute>
          }
        />
      ))}
    </Routes>
  );
};

export default AppRoutes;
